import React from 'react';
import {Form, Button,  Table, Input, Col, Row, InputNumber, message, Tooltip} from 'antd';
import ModalDom from '../../../components/Modal';
import { CustomRow, CustomCol } from '../../../components/Custom';
import { postFrom, config } from '../../../axios';
import moment from 'moment'
import ActionRecords from '../../ActionRecords/index';
import { moneyAddComma,floatObj,handleExportParams,digitUppercase } from '../../../utils/index'

class Page extends React.Component {




    constructor() {
        super();
            var today = new Date(),
            _date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        this.state = {
            loading: false,
            InputWidth: "185px",
            shortInputWidth: "154px",
            actionVisible: false,
            buildingName:'',
            roomNo:'',
            customerName:'',
            cycleIn:'',
            totalAmount: 0,
            feeRemark: '',
            data: {},
            today: _date
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    loadPackage = (houseId,cycleIn,customerId,buildingName,roomNo,customerName) => {
        this.setState({ loading: true,cycleIn: cycleIn,buildingName:buildingName,roomNo:roomNo,customerName:customerName });
        let data = { houseId: houseId, customerId:customerId,cycleIn:cycleIn};
        postFrom({ url: config.API_Bill_findPrintReceiptListByCustomerId, data }).then(res => {
            console.log(res);

            let _totalAmount=0;
            let _feeRemark = '';
            if(res instanceof Array && res.length > 0){
                for(var i=0;i<res.length;i++){
                    _totalAmount=floatObj().add(_totalAmount,res[i].receivedMoney);
                    if((res[i].feeName==='租金' || res[i].feeName==='宽带费'||res[i].feeName==='物业费' || res[i].feeName==='常规押金') && res[i].feeRemark!=null && res[i].feeRemark!=''){
                        _feeRemark += res[i].feeRemark+";";
                    }
                }
            }

            this.setState({ data: res, loading: false,totalAmount:_totalAmount,feeRemark:_feeRemark });
        }).catch(err => {
            message.error(err.message || '获取收据打印详情失败！');
            this.setState({ loading: false });
        })
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
        })
    }


    printReceiptInfo = () => {
        window.document.body.innerHTML = document.getElementById('printHtml').innerHTML;
        window.print();
        window.location.reload();
    }


    render() {
        let { visible, handleCancel, form: { getFieldDecorator } } = this.props;
        let {
            loading,
            data,
            actionVisible,
            totalAmount
        } = this.state;



        return <ModalDom
            title="收款收据单"
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={handleCancel}
            footer={
                <div>
                    <Button  onClick={this.printReceiptInfo }>打印</Button>
                    <Button onClick={handleCancel}>关闭</Button>
                </div>
            }
        >
            <ActionRecords
                onRef={ref => this.onAction = ref}
                visible={actionVisible}
                handleCancel={() => { this.setState({ actionVisible: false }) }}
            />

            <div className="custom" id={'printHtml'}>
                <Form labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}>
                    <Row style={{paddingTop:30,paddingBottom:30}}>
                        <Col>
                            <div style={{display: 'flex',}}>
                                <h2 style={{flex: 1, textAlign: 'center'}}>收款收据</h2>
                            </div>
                            <div style={{display: 'flex'}}>
                                <h3 style={{flex: 1, textAlign: 'center'}}>租客：{this.state.customerName}
                                </h3>
                                <h3 style={{flex: 3}}>房间：{this.state.buildingName+'-'+this.state.roomNo}</h3>
                                <h3 style={{flex: 1,textAlign: 'center'}}>No：{this.state.cycleIn}</h3>
                            </div>
                        </Col>

                        <Col>
                                <table style={{border: '1px solid #0094ff'}}>
                                    <tr style={{ height: 30 }}>
                                        <th style={{ width: 120, border: '1px solid rgb(12 12 12)',textAlign:'center',verticalAlign:'middle'}} >费用项目</th>
                                        <th style={{ width: 120,border: '1px solid rgb(12 12 12)' ,textAlign:'center',verticalAlign:'middle'}}>开始时间</th>
                                        <th style={{ width: 120,border: '1px solid rgb(12 12 12)',textAlign:'center',verticalAlign:'middle' }}>结束时间</th>
                                        <th style={{ width: 120 ,border: '1px solid rgb(12 12 12)',textAlign:'center',verticalAlign:'middle'}}>起数</th>
                                        <th style={{ width: 120 ,border: '1px solid rgb(12 12 12)',textAlign:'center',verticalAlign:'middle'}}>止数</th>
                                        <th style={{ width: 120 ,border: '1px solid rgb(12 12 12)',textAlign:'center',verticalAlign:'middle'}}>用量</th>
                                        <th style={{ width: 120 ,border: '1px solid rgb(12 12 12)',textAlign:'center',verticalAlign:'middle'}}>单价</th>
                                        <th style={{ width: 120,border: '1px solid rgb(12 12 12)' ,textAlign:'center',verticalAlign:'middle'}}>金额</th>
                                    </tr>
                                        {
                                            data instanceof Array && data.length > 0 ?
                                                data.map((item, index) => {
                                                    return (
                                                        <tr  style={{ height: 30 }} key={index}>
                                                            <td style={{ flex: 1 ,border: '1px solid rgb(12 12 12)',textAlign:'center',verticalAlign:'middle'}}>{item.feeName}</td>
                                                            <td style={{ flex: 1,border: '1px solid rgb(12 12 12)' ,textAlign:'center',verticalAlign:'middle'}}>{item.billBeginDate ? moment(item.billBeginDate).format('YYYY-MM-DD') : null}</td>
                                                            <td style={{ flex: 1 ,border: '1px solid rgb(12 12 12)',textAlign:'center',verticalAlign:'middle'}}>{item.billEndDate ? moment(item.billEndDate).format('YYYY-MM-DD') : null}</td>
                                                            <td style={{ flex: 1 ,border: '1px solid rgb(12 12 12)',textAlign:'right',verticalAlign:'middle'}}>{item.beginNum!=null ? item.beginNum:'-'}</td>
                                                            <td style={{ flex: 1,border: '1px solid rgb(12 12 12)' ,textAlign:'right',verticalAlign:'middle'}}>{item.endNum!=null ? item.endNum:'-'}</td>
                                                            <td style={{ flex: 1,border: '1px solid rgb(12 12 12)' ,textAlign:'right',verticalAlign:'middle'}}>{(item.beginNum!=null&&item.endNum!=null)?(floatObj().subtract(item.endNum,item.beginNum)):((item.beginNum==null&&item.endNum==null)?'-':item.beginNum!=null?item.beginNum:item.endNum)}</td>
                                                            <td style={{ flex: 1 ,border: '1px solid rgb(12 12 12)',textAlign:'right',verticalAlign:'middle'}}>{item.unitPrice!=null ? item.unitPrice:'-'}</td>
                                                            <td style={{ flex: 1,border: '1px solid rgb(12 12 12)' ,textAlign:'center',verticalAlign:'middle'}}>{moneyAddComma(item.receivedMoney)}</td>
                                                        </tr>
                                                    )
                                                },
                                               )

                                                : <div className="tableBodyRow" style={{ justifyContent: 'center', lineHeight: '34px' }}>
                                                    暂无数据！
                                            </div>



                                        }
                                           {
                                            data instanceof Array && data.length > 0 ?
                                            <tr  style={{ height: 30 }}>
                                                <td style={{ flex: 1 ,border: '1px solid rgb(12 12 12)',textAlign:'center',verticalAlign:'middle'}}>实收合计</td>
                                                <td style={{ flex: 1 ,border: '1px solid rgb(12 12 12)',textAlign:'center',verticalAlign:'middle'}} colSpan='5'>￥{moneyAddComma(this.state.totalAmount)}（{digitUppercase(this.state.totalAmount)}）</td>
                                                <td style={{ flex: 1 ,border: '1px solid rgb(12 12 12)',textAlign:'center',verticalAlign:'middle'}} >支付方式</td>
                                                <td style={{ flex: 1 ,border: '1px solid rgb(12 12 12)',textAlign:'center',verticalAlign:'middle'}} >微信支付</td>
                                            </tr>:''
                                          }
                                            {
                                                data instanceof Array && data.length > 0 ?
                                                    <tr  style={{ height: 30 }}>
                                                        <td style={{ flex: 1 ,border: '1px solid rgb(12 12 12)',textAlign:'center',verticalAlign:'middle'}} rowSpan='3'>备注</td>
                                                        <td style={{ flex: 1 ,border: '1px solid rgb(12 12 12)',textAlign:'left',verticalAlign:'middle'}} colSpan='7' rowSpan='3'>{this.state.feeRemark}</td>
                                                    </tr>:''
                                            }
                                            {
                                                data instanceof Array && data.length > 0 ?
                                                    <tr  style={{ height: 30 }}>

                                                    </tr>:''
                                            }
                                            {
                                                data instanceof Array && data.length > 0 ?
                                                    <tr  style={{ height: 30 }}>

                                                    </tr>:''
                                            }
                                </table>
                        </Col>

                        <Col>
                            <div>&nbsp;&nbsp;&nbsp;&nbsp;</div>
                            <div style={{display: 'flex'}}>
                                <h3 style={{flex: 1, textAlign: 'center'}}>打印日期：{this.state.today}
                                </h3>
                                <h3 style={{flex: 1}}>经办人：{decodeURIComponent(handleExportParams().merchantUserName)}</h3>
                                <h3 style={{flex: 1,textAlign: 'center'}}>付款人：{this.state.customerName}</h3>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }


}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Bill/PrintReceipt/Detail.js